import { createSelector } from 'reselect';
import { makeSelectQuery } from '../app/selectors';
import { makeSelectOtConsentEnabled as makeSelectOtConsentEnabledFromSettings } from '../settings/selectors';

const makeSelectOtConsent = () =>
  createSelector(makeSelectQuery(), query => query.otConsent === true);

const makeSelectIsOtConsentEnabled = () =>
  makeSelectOtConsentEnabledFromSettings();

const makeSelectIsOtConsentToggleOn = () =>
  createSelector(
    makeSelectOtConsent(),
    makeSelectIsOtConsentEnabled(),
    (otConsent, otConsentEnabled) => otConsent && otConsentEnabled
  );

export {
  makeSelectOtConsent,
  makeSelectIsOtConsentEnabled,
  makeSelectIsOtConsentToggleOn,
};